export default __webpack_public_path__ + "static/social-image-twitter-919702854a1823eee6591ae21608a47d.png";